<template lang="html">
  <input class="button" type="button" name="button" value="点我呀"/>
</template>

<script>
export default {
  name: 'jy-button',
  data () {
    return{
    }
  }
}
</script>

<style lang="css">
.button{
  border: 1px solid #000;
  background: none;
  padding: 4px 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/buttonModel/button.vue